import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import VueMeta from 'vue-meta'
import VueTheMask from 'vue-the-mask'
import { Skeleton, Timeline, Icon } from 'ant-design-vue';
import VueLazyload from 'vue-lazyload'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import JsonExcel from "vue-json-excel";
import './global.scss'
import 'ant-design-vue/dist/antd.css';
import { longClickDirective } from 'vue-long-click'


Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.use (IconsPlugin);
Vue.use(VueMeta);
Vue.use(VueTheMask);
Vue.use(Skeleton);
Vue.use(Timeline);
Vue.use(Icon);
Vue.component('VueSlider', VueSlider);
Vue.component("downloadExcel", JsonExcel);

const longClickInstance = longClickDirective({delay: 400, interval: 50});
Vue.directive('longclick', longClickInstance);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'https://media.tenor.com/images/1f0521020b6e6ed69896d02906e84b8e/tenor.gif',
  attempt: 1
})

Vue.prototype.moment = moment

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
